module.exports = __webpack_public_path__ + "static/media/arrow_down_blue.ce60aef1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/arrow_down_blue.svg
// module id = 824
// module chunks = 147